import PropTypes from "prop-types";
import { Component } from "react";
import ReactGA from "react-ga4";

export default class OutboundLink extends Component {
  static propTypes = {
    alt: PropTypes.string,
    ariaLabel: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    className: PropTypes.string,
    dangerouslySetInnerHTML: PropTypes.shape({ __html: PropTypes.string }),
    title: PropTypes.string,
    url: PropTypes.string.isRequired,
    utm_medium: PropTypes.string,
    utm_source: PropTypes.string,
  };

  handleClick = (event) => {
    const { url } = this.props.url;

    event.preventDefault();
    ReactGA.event({ action: "click", category: "Outbound", label: url });
    window.location.href = url;
  };

  render() {
    const { alt, ariaLabel, children, className, dangerouslySetInnerHTML, title, url, utm_medium, utm_source } =
      this.props;

    let href = url;
    try {
      const parsedUrl = new URL(href);
      parsedUrl.searchParams.set("utm_source", "edhrec");
      if (utm_medium) parsedUrl.searchParams.set("utm_medium", utm_medium);
      if (utm_source) parsedUrl.searchParams.set("utm_source", utm_source);
      href = parsedUrl.href;
    } catch (error) {
      console.warn(`Invalid URL: ${url}`);
    }

    return (
      <a
        alt={alt}
        aria-label={ariaLabel}
        className={className}
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
        href={href}
        rel="noopener noreferrer"
        target="_blank"
        title={title}
      >
        {children}
      </a>
    );
  }
}
